/**
 * クリップボードへのコピー（`feature-gate 用にコピー` U-8 / `識別子をコピー` U-21）。
 * 成功: ボタンのラベルが 2 秒 `コピーしました`。失敗: ボタンの下に 1 行（I12）。
 */
import { useEffect, useState } from 'react';

const COPIED_MS = 2000;

export function CopyButton({ label, text }: { label: string; text: string }) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');

  useEffect(() => {
    if (state !== 'copied') return;
    const t = setTimeout(() => setState('idle'), COPIED_MS);
    return () => clearTimeout(t);
  }, [state]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
  };

  return (
    <span className="inline-flex flex-col">
      <button type="button" onClick={() => void copy()} className="text-slate-600 underline">
        {state === 'copied' ? 'コピーしました' : label}
      </button>
      {state === 'failed' && (
        <span className="mt-1 text-xs text-slate-600">
          コピーできませんでした。本文を選択してコピーしてください。
        </span>
      )}
    </span>
  );
}
